module.exports = __webpack_public_path__ + "img/minus-square.27ec0315.svg";